import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../constants';

const GoogleCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = new URLSearchParams(location.search).get('code');

    if (code) {
      axios
        .post(API_URL + 'authy/google/', { code })
        .then((response) => {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem(
            'userData',
            JSON.stringify({
              username: response.data.username,
              profilePicture: response.data.profile_picture,
              status: response.data.status,
            })
          );
          navigate('/dashboard');
        })
        .catch((err) => {
          setError(err.response?.data?.error || 'An error occurred during login.');
        });
    }
  }, [location, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      {error ? (
        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
          <h2 className="text-2xl text-black font-semibold text-center mb-6">
            Login Failed
          </h2>
          <div className="mb-4 p-2 bg-red-100 text-red-700 rounded-md">
            {error}
          </div>
        </div>
      ) : (
        <div className="text-center">
          <p>Authenticating with Google...</p>
        </div>
      )}
    </div>
  );
};

export default GoogleCallback;
